import VacancyCardSlider from './VacancyCardSlider.vue'

export default VacancyCardSlider
